  <!-- Cabecera de Página Responsive -->
  <app-page-header
    [title]="pageHeaderTitle()"
    [mobileTitle]="pageHeaderTitle()"
    [icon]="selectedMail() ? undefined : 'fas fa-envelope-open-text'"
    [showBack]="appSettings.isMobile() && !!selectedMail()"
    [unifiedOnMobile]="!!selectedMail()"
    (back)="onBackToList()"
    [hasOptions]="false">
    @if (appSettings.isMobile() && selectedMail()) {
      <div headerExtra class="d-flex align-items-center">
        @if (selectedMail()?.status === 'SENT') {
          <span class="badge bg-success">ENVIADO</span>
        } @else if (selectedMail()?.status === 'FAILED') {
          <span class="badge bg-danger">FALLIDO</span>
        } @else {
          <span class="badge bg-warning text-dark">OMITIDO</span>
        }
      </div>
    } @else {
      <div headerExtra class="d-flex align-items-center gap-2">
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="loadData(false)" [disabled]="loading()">
          <i class="fas fa-sync-alt me-1" [class.fa-spin]="loading()"></i> Actualizar
        </button>
      </div>
    }
  </app-page-header>

  <!-- Layout Maestro-Detalle -->
  <div class="row g-3">
    <!-- Columna Izquierda: Maestro (siempre visible en escritorio) -->
    @if (!appSettings.isMobile() || !selectedMail()) {
      <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-3'">
          <app-mail-list
            [items]="items()"
            [loading]="loading()"
            [loadingMore]="loadingMore()"
            [selectedUuid]="selectedMail()?.uuid ?? null"
            [total]="total()"
            [searchQuery]="searchQuery()"
            [activeStatus]="activeStatus()"
            (searchQueryChange)="onSearchChange($event)"
            (activeStatusChange)="onStatusChange($event)"
            (selectMail)="onSelectMail($event)"
            (loadMore)="onLoadMore()">
          </app-mail-list>
      </div>
    }

    <!-- Columna Derecha: Detalle -->
    @if (!appSettings.isMobile() || selectedMail()) {
      <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-9'">
        <app-mail-detail
          [mailItem]="selectedMail()"
          (backToList)="onBackToList()"
          (onResent)="onMailResent()">
        </app-mail-detail>
      </div>
    }
  </div>

